import React from "react";
import { GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql";
import withQuery from "../wrappers/gql/withQuery";

const RelinkBankHeader = ({ data: applicationInfo }) => {

  const { getBankAccounts } = applicationInfo;
  const { unlinkedAccountsFound } = getBankAccounts;

  const headerText = unlinkedAccountsFound ?
    "Some of your accounts need to be re-linked" :
    "You're good to go!";
  const headerDescription = unlinkedAccountsFound ?
    "We had an issue with the following accounts. Please re-link to continue" :
    "You have no more accounts that need linking";

  return (
    <>
      <div className="stepDescriptionText">
        {headerText}
      </div>
      <div className="font-gilroy font-light text-md pb-3 px-10 md:px-0">
        {headerDescription}
      </div>
    </>
  );
};

export default withQuery(GET_APP_INFO_AND_ACCOUNTS)(RelinkBankHeader);